module.exports = "/_next/static/images/LowRecencyPurchaseWinbackMobile-8c6deef9990b9290c5751fac26e9087d.png";